import React, { Component } from 'react'
import { connect } from 'react-redux'
import { OverlayTrigger, Overlay, Popover } from 'react-bootstrap'
import { injectIntl, FormattedMessage } from 'react-intl'
import { editModalAriaLabel } from '../../Constants/AriaLabelText'
// Text map for aspire module (aspire.saveBtn)
const p = {
  // "aspire.saveBtn.savePopover": "* The changes you perform will not be reflected to LinkedIn",
  // "aspire.saveBtn.saveAriaLabel": "{saving, select, true {Saving changes} other {Save changes}}",
  // "aspirse.saveBtn.saveButtonText": "{saving, select, true {Saving...} other {Save}}"
}


class SaveBtn extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { savingChanges, saveDisabled, handleSaveChanges, intl } = this.props
    let popOverSave = (
      <Popover id="popover-save-btn" className="as-popover">
        <FormattedMessage
          id="aspire.saveBtn.savePopover"
          defaultMessage="* The changes you perform will not be reflected to LinkedIn"
        />
      </Popover>
    )
    return (
      <OverlayTrigger
        trigger={['hover', 'focus']}
        rootClose
        placement="bottom"
        overlay={popOverSave}
      >
        <button
          tabIndex={0}
          aria-label={editModalAriaLabel(intl)[savingChanges ? 'saving' : 'save']}
          className={`btn btn-primary btn-save-changes ${
            savingChanges && 'cusrsor-not-allowed'
          }`}
          onClick={() => {
            if (!savingChanges) {
              handleSaveChanges()
            }
          }}
          disabled={savingChanges ? true : saveDisabled}
        >
          <FormattedMessage
            id="aspire.saveBtn.saveButtonText"
            defaultMessage="{saving, select, true {Saving...} other {Save}}"
            values={{ saving: savingChanges }}
          />
        </button>
      </OverlayTrigger>
    )
  }
}

export default injectIntl(SaveBtn)
